<template>
  <div id="foto-galeria">
    <!-- Dialogo para eliminar una Calificación -->
    <v-dialog
      v-if="fotos[deletedIndex]"
      v-model="dialogDeleteItem"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline">Eliminar Imagen</v-card-title>
        <v-card-text
          >Estas seguro que deseas eliminar la imagen
          <span style="color: red">{{ fotos[deletedIndex].imagen }}</span>
          ?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDeletedDialog"
            >Cerrar</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="deleteItem(fotos[deletedIndex])"
            >Eliminar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End - Dialogo para eliminar una Calificación -->

    <v-container fluid>
      <v-row dense>
        <v-col v-for="foto in fotos" :key="foto.id" :cols="cardFlex">
          <v-card>
            <v-img
              :src="`${imgDir}galerias/productos/thumb_${foto.imagen}`"
              :height="imageHeight"
            >
            </v-img>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn icon @click="openDeletedDialog(foto)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { ref } from "@vue/composition-api";
import { createNamespacedHelpers } from "vuex-composition-helpers";
const { useState } = createNamespacedHelpers("galerias");
import { imageService } from "@/services/imageService";

export default {
  name: "GaleriaDetalles",
  props: {
    idProducto: {
      type: Number,
      required: true
    }
  },
  setup(props, { root }) {
    const cardFlex = ref(3);
    const imageHeight = ref("120px");
    const deletedIndex = ref(-1);
    const dialogDeleteItem = ref(false);

    const { imgDir } = imageService(root);

    const { fotos } = useState(["fotos"]);

    const init = () => {
      root.$store
        .dispatch("getProductoGaleria", props.idProducto)
        .then(response => {
          root.$store.commit("SET_GALERIA", response);
        })
        .catch(error => {
          console.log(error);
        });
    };

    const deleteItem = item => {
      root.$store
        .dispatch("deleteFotoGaleria", item)
        .then(response => {
          root.$store.commit("SET_GALERIA", response.galeria);
          deletedIndex.value = -1;
        })
        .catch(error => {
          console.log(error);
        });
    };

    const openDeletedDialog = item => {
      deletedIndex.value = fotos.value.indexOf(item);
      dialogDeleteItem.value = true;
    };

    const closeDeletedDialog = () => {
      deletedIndex.value = -1;
      dialogDeleteItem.value = false;
    };

    init();

    return {
      cardFlex,
      imageHeight,
      imgDir,
      fotos,
      deletedIndex,
      dialogDeleteItem,
      openDeletedDialog,
      closeDeletedDialog,
      deleteItem
    };
  }
};
</script>
